let apiUrls = [{
  root: '',
  mapper: {
    face: {
      MILLION_RETRIEVAL: '/v2/ytface_ctl/apply'
    },
    user: {
      // YTPRELOGIN: '/v2/ytuser_ctl/prelogin', open qc.js 使用
      // YTLOGIN: '/v2/welcome/on_qc_login',

      YTSTATUS: '/v2/ytuser_ctl/status',
      YTGET_CODE: '/v2/ytuser_ctl/getcode',
      YTVERIFY_INFO: '/v2/ytuser_ctl/verifyinfo',
      YTLOGOUT: '/v2/ytuser_ctl/logout',
      YTMAIL: '/v2/ytuser_ctl/regemail',

      LOGOUT: '/user_ctl/log_out',
      AUTH: '/welcome/auth',
      GET_CODE: '/welcome/get_code',
      VERIFY_INFO: '/welcome/verify_info',
      MAIL: '/user_ctl/send_mail_new'
    },
    app: {
      SEARCH_ALL_APP: '/soft_ctl/get_all_app',
      CREATE_APP: '/soft_ctl/create',
      REMOVE_APP: '/soft_ctl/delete',
      CHANGE_FORMAL: '/soft_ctl/activate',
      FILTER_APP: '/soft_ctl/filter_apps',
      APPROVE_APP: '/soft_ctl/approve',
      REJECT_APP: '/soft_ctl/reject',
      STOP_APP: '/soft_ctl/disable'
    },
    message: {
      MESSAGE: '/v2/ytinformation_ctl/get'
    },
    faceMerge: {
      GET_BY_ID: '/index.php/Stg/MaterialOuter/ajaxQuery',
      DELETE_TEMPLATE: '/index.php/Stg/MaterialOuter/ajaxDel',
      ADD_TEMPLATE: '/index.php/Stg/MaterialOuter/ajaxAdd'
    },
    sdk: {
      SEARCH_SDK_BY_ID: '/sdk_ctl/get_sdk_by_softid',
      CREATE_SDK: '/sdk_ctl/create',
      REMOVE_SDK: '/sdk_ctl/delete',
      REJECT_SDK: '/sdk_ctl/reject_sdk',
      APPLY_AUTH: '/sdk_ctl/apply_authorization',
      SEARCH_SDK_CONDITION: '/sdk_ctl/get_sdk_multi_condition',
      PASS_SDK: '/sdk_ctl/pass_sdk',
      UPLOAD_COOPERATION_RECORD: '/sdk_ctl/upload_cooperation_record'
    },
    device: {
      SEARCH_DEVICE_BY_ID: '/device_ctl/get_devices_by_sdkid',
      REMOVE_DEVICE: '/device_ctl/delete',
      CREATE_DEVICE: '/device_ctl/create'
    },
    ytsdk: {
      CREATE_YTSDK: '/v2/ytsdk_ctl/create',
      GET_ALL_YTSDK: '/v2/ytsdk_ctl/list',
      REVIEW_YTSDK: '/v2/ytsdk_ctl/review',
      REMOVE_YTSDK: '/v2/ytsdk_ctl/delete',
      PRODUCTIZE_AUTH: '/v2/ytsdk_ctl/productize',
      MAIL: '/v2/ytsdk_ctl/mailreceiver',
      RENEWAL: '/v2/ytsdk_ctl/renewal',

      GET_YTSDK_INFO: '/v2/ytsdk_ctl/get',
      BIND_DEVICE: '/v2/ytsdk_ctl/bind',
      MULTIBIND_DEVICE: '/v2/ytsdk_ctl/multibind',
      REMOVE_DEVICE: '/v2/ytsdk_ctl/unbind',
      EXPORT: '/v2/ytsdk_ctl/export',
      BIND_DEVICE_INFO: '/v2/ytsdk_ctl/deviceinfo',
      UPDATE_REMARKS: '/v2/ytsdk_ctl/deviceremark',
      QUERY_LICENSE: '/v2/ytsdk_ctl/query_license',

      APPID_DISABLE: '/v2/ytappid_ctl/disable'
    },
    ytsdktype: {
      GET_ALL_SDKTYPE: '/v2/ytsdktype_ctl/list'
    },
    ytprivatetype: {
      GET_ALL_PRIVATETYPE: '/v2/ytprivatetype_ctl/list'
    },
    ytpublic: {
      CREATE_YTPUBLIC: '/v2/ytpublic_ctl/create',
      GET_ALL_YTPUBLIC: '/v2/ytpublic_ctl/list',
      SEARCH_YTPUBLIC_CONDITION: '/ytpublic_ctl/search',
      REVIEW_YTPUBLIC: '/v2/ytpublic_ctl/review',
      REMOVE_YTPUBLIC: '/v2/ytpublic_ctl/delete',

      GET_YTPUBLIC_INFO: '/v2/ytpublic_ctl/get',
      EXPORT: '/v2/ytpublic_ctl/export'
    },
    ytbox: {
      CREATE_YTBOX: '/v2/ytbox_ctl/create',
      GET_ALL_YTBOX: '/v2/ytbox_ctl/list',
      REVIEW_YTBOX: '/v2/ytbox_ctl/review',
      REMOVE_YTBOX: '/v2/ytbox_ctl/delete',
      PRODUCTIZE_AUTH: '/v2/ytbox_ctl/productize',
      MAIL: '/v2/ytbox_ctl/mailreceiver',
      RENEWAL: '/v2/ytbox_ctl/renewal',

      GET_YTBOX_INFO: '/v2/ytbox_ctl/get',
      BIND_DEVICE: '/v2/ytbox_ctl/bind',
      MULTIBIND_DEVICE: '/v2/ytbox_ctl/multibind',
      REMOVE_DEVICE: '/v2/ytbox_ctl/unbind',
      EXPORT: '/v2/ytbox_ctl/export'
    },
    ytprivate: {
      CREATE_YTPRIVATE: '/v2/ytprivate_ctl/create',
      GET_ALL_YTPRIVATE: '/v2/ytprivate_ctl/list',
      REVIEW_YTPRIVATE: '/v2/ytprivate_ctl/review',
      REMOVE_YTPRIVATE: '/v2/ytprivate_ctl/delete',
      PRODUCTIZE_AUTH: '/v2/ytprivate_ctl/productize',
      MAIL: '/v2/ytprivate_ctl/mailreceiver',
      RENEWAL: '/v2/ytprivate_ctl/renewal',

      GET_YTPRIVATE_INFO: '/v2/ytprivate_ctl/get',
      BIND_DEVICE: '/v2/ytprivate_ctl/bind',
      MULTIBIND_DEVICE: '/v2/ytprivate_ctl/multibind',
      REMOVE_DEVICE: '/v2/ytprivate_ctl/unbind',
      EXPORT: '/v2/ytprivate_ctl/export',
      BIND_DEVICE_INFO: '/v2/ytprivate_ctl/deviceinfo',
      BIND_CENTER: '/v2/ytprivate_ctl/centerbind',
      UPDATE_REMARKS: '/v2/ytprivate_ctl/deviceremark',
      QUERY_LICENSE: '/v2/ytprivate_ctl/query_license'
    },

    ytdelivery: {
      CREATE_DELIVERY: '/v2/ytdelivery_ctl/create',
      GET_DELIVERY_LIST: '/v2/ytdelivery_ctl/list',
      CREATE_DOWNLOAD: '/v2/ytdelivery_ctl/create_download'
    },

    ytbusiness: {
      QUERY_SERVICE: '/v2/ytbusinessreview_ctl/create',
      QUERY_PRODUCT: '/v2/ytbusinessreview_ctl/product'
    }
  }
}];

let api = {};

apiUrls.forEach(createPath);

function createPath(apiPair) {
  let rootPath = apiPair.root;
  let mapper = apiPair.mapper;
  for (let name in mapper) {
    if (mapper.hasOwnProperty(name)) {
      let mapperItem = mapper[name];
      let apiItem = {};
      api[name] = apiItem;

      for (let itemName in mapperItem) {
        if (mapperItem.hasOwnProperty(itemName)) {
          let url = rootPath + mapperItem[itemName];
          apiItem[itemName] = url;
        }
      }
    }
  }
}

export default api;



// WEBPACK FOOTER //
// ./src/common/api.js